import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

import { Img } from 'utilities/components/img/component';

import { paths } from 'utilities/routes';

import './view.scss';

export const PromotedPostView = ({ post }) => (
    <section className="promoted-post">
        <Link className="promoted-post__container" to={ `${paths.artykul}/${post.slug}-${post.alternative_id}` }>
            <div className="promoted-post__detail">
                <div className="promoted-post__wrapper">
                    <Img className="promoted-post__image" src={ `${process.env.GATSBY_URL}/${post.promoted_image || post.image_main}` } alt={ post.promoted_title || post.title } />
                </div>
            </div>
            <div className="promoted-post__details">
                <p className="promoted-post__reading-time">
                    {post.reading_time}
                    {' '}
                    czytania
                </p>
                <h4 className="promoted-post__title">
                    {post.promoted_title || post.title}
                </h4>
                <p className="promoted-post__description">
                    {post.promoted_lead || post.lead}
                </p>
                <p className="promoted-post__read-more">
                    Czytaj więcej
                </p>
            </div>
        </Link>
    </section>
);

PromotedPostView.propTypes = {
    post: PropTypes.instanceOf(Object).isRequired
};